import { Box, Button, HStack, Link, Paragraph, Text, View } from "components/ui";
import React from "react";
import footerLogo from "assets/footerLogo.svg";
import { Image as RNImage, SafeAreaView, useWindowDimensions } from "react-native";
import { Image } from "components/ui";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { ComponentProps } from "react";
import { Linking } from "react-native";
import { useSiteRegion } from "utils/hooks/useSiteSection";
const Footer = (props: ComponentProps<typeof Box>) => {
	const { width: windowWidth } = useWindowDimensions();
	const isMobile = useIsMobile();
	const region = useSiteRegion();

	var phone = "1800 177 399";
	var email = "customer.service@abcopro.com.au";
	var hours = "7.00am - 2.30am AEST";

	if (region == "nz") {
		phone = "0800 277 678";
		email = "customerservices@proquipnz.co.nz";
		hours = "7.00am - 5.00pm";
	}

	if (isMobile) {
		return (
			<SafeAreaView>
				<Box paddingVertical={32} gap={16} paddingHorizontal={16} width={"$full"} backgroundColor="$darkteal">
					{/* {region === "au" && <Image style={{ width: 141, height: 35, marginBottom: 12 }} resizeMode="contain" source={require("../../assets/footerLogo.png")} alt="Abco Logo" />} */}
					{region === "au" && <Image style={{ width: 141, height: 35, marginBottom: 12 }} resizeMode="contain" source={require("../../assets/footerLogo.png")} alt="Abco Logo" />}
					{region === "nz" && <Image resizeMode="contain" source={require("../../assets/logo-nz-white.svg")} alt="Abco: The Power to Clean 2" style={{ width: 250, height: 72 }} />}
					{region === "nz" && (
						<Link href="http://www.bsc.org.nz/news/bscnz-launches-its-inaugural-conference-cleaning-for-a-brighter-future/">
							<Image style={{ marginBottom: 32, width: 200, height: 100 }} resizeMode="contain" source={require("../../assets/bsc-logo-white.png")} />
						</Link>
					)}
					{/*  */}
					<Box flex={1}>
						<Text color="$basicwhite" fontWeight={"$bold"} fontFamily="calibri" lineHeight={24}>
							Contact
						</Text>
						<Link href={"tel:" + phone}>
							<Button justifyContent="flex-start" padding={0}>
								<Text color="$basicwhite" fontSize={28}>
									{phone}
								</Text>
							</Button>
						</Link>
						<Link href={"mailto:" + email}>
							<Button justifyContent="flex-start" padding={0}>
								<Text color="$basicwhite" fontFamily="calibri">
									{email}
								</Text>
							</Button>
						</Link>
					</Box>
					<Box flexDirection="row" alignContent="space-between" my={24}>
						<Box flex={1}>
							<Text color="$basicwhite" fontFamily="calibri" lineHeight={24}>
								Hours
							</Text>
							<Text color="$basicwhite" fontFamily="calibri" lineHeight={24}>
								Mon - Fri
							</Text>
							<Text color="$basicwhite" fontFamily="calibri" lineHeight={24}>
								{hours}
							</Text>
						</Box>
						<Box flex={1}>
							<Link
								href="/terms-and-conditions"
								component={(hovered) => (
									<Text color="$basicwhite" fontFamily="calibri" lineHeight={24} textDecorationLine={hovered ? "underline" : "none"}>
										Terms and Conditions
									</Text>
								)}
							/>
							<Link
								href="/disclaimer"
								component={(hovered) => (
									<Text color="$basicwhite" fontFamily="calibri" lineHeight={24} textDecorationLine={hovered ? "underline" : "none"}>
										Disclaimer
									</Text>
								)}
							/>
							<Link
								href="/privacy-policy"
								component={(hovered) => (
									<Text color="$basicwhite" fontFamily="calibri" lineHeight={24} textDecorationLine={hovered ? "underline" : "none"}>
										Privacy Policy
									</Text>
								)}
							/>
							<Link
								href="/shipping-and-returns"
								component={(hovered) => (
									<Text color="$basicwhite" fontFamily="calibri" lineHeight={24} textDecorationLine={hovered ? "underline" : "none"}>
										Shipping and Returns
									</Text>
								)}
							/>
						</Box>
					</Box>
					{region == "au" && (
						<Box flex={2} gap={4}>
							<Box flex={2} gap={4} mb={32}>
								<Text fontWeight={"$bold"} color="$basicwhite">
									© {new Date().getFullYear()} Abco Products Pty Ltd
								</Text>
								<Text color="$basicwhite" lineHeight={24} fontFamily="calibri" flexWrap="wrap" style={{ flex: 1, flexWrap: "wrap" }}>
									Abco acknowledges the Traditional Owners of the land where we work and live. We pay our respects to Elder's past, present and emerging. We celebrate the stories, culture and traditions of Aboriginal and
									Torres Strait Islanders of all communities who also work and live on this land.
								</Text>
							</Box>
						</Box>
					)}
					{region == "nz" && (
						<Box flex={2} gap={4}>
							<Box flex={2} gap={4} mb={32}>
								<Text fontWeight={"$bold"} color="$basicwhite">
									© {new Date().getFullYear()} Proquip NZ Pty Ltd
								</Text>
							</Box>
						</Box>
					)}
				</Box>
			</SafeAreaView>
		);
	}
	return (
		<View width={"$full"} backgroundColor="$darkteal">
			<Box
				sx={{
					"@md": { width: windowWidth, paddingLeft: 10, paddingRight: 10, display: "flex" },
					"@lg": { width: windowWidth, paddingLeft: 15, paddingRight: 15 },
					"@xl": { width: "$containerWidthXL" },
				}}
				marginLeft="auto"
				marginRight="auto"
			>
				<Box {...props} paddingHorizontal={28} paddingVertical={48}>

					{region === "au" && <RNImage source={footerLogo} style={{ marginBottom: 32 }} />}
					{region === "nz" && <RNImage source={require("../../assets/logo-nz-white.svg")} style={{ marginBottom: 32 }} />}

					<Box flexDirection="row" gap={32}>
						<Box flex={1} gap={6}>
							<Text color="$basicwhite" fontFamily="calibri" lineHeight={24}>
								Contact
							</Text>
							<Link href={"tel:" + phone}>
								<Button justifyContent="flex-start" padding={0}>
									<Text color="$basicwhite" fontSize={28}>
										{phone}
									</Text>
								</Button>
							</Link>
							<Link href={"mailto:" + email}>
								<Button justifyContent="flex-start" padding={0}>
									<Text color="$basicwhite" fontFamily="calibri">
										{email}
									</Text>
								</Button>
							</Link>
						</Box>
						<Box flex={1}>
							<Text color="$basicwhite" fontFamily="calibri" lineHeight={24}>
								Hours
							</Text>
							<Text color="$basicwhite" fontFamily="calibri" lineHeight={24}>
								Mon - Fri
							</Text>
							<Text color="$basicwhite" fontFamily="calibri" lineHeight={24}>
								{hours}
							</Text>
						</Box>
						<Box flex={1} gap={6}>
							<Link
								href="/terms-and-conditions"
								component={(hovered) => (
									<Text color="$basicwhite" fontFamily="calibri" lineHeight={24} textDecorationLine={hovered ? "underline" : "none"}>
										Terms and Conditions
									</Text>
								)}
							/>
							<Link
								href="/disclaimer"
								component={(hovered) => (
									<Text color="$basicwhite" fontFamily="calibri" lineHeight={24} textDecorationLine={hovered ? "underline" : "none"}>
										Disclaimer
									</Text>
								)}
							/>
							<Link
								href="/privacy-policy"
								component={(hovered) => (
									<Text color="$basicwhite" fontFamily="calibri" lineHeight={24} textDecorationLine={hovered ? "underline" : "none"}>
										Privacy Policy
									</Text>
								)}
							/>
							<Link
								href="/shipping-and-returns"
								component={(hovered) => (
									<Text color="$basicwhite" fontFamily="calibri" lineHeight={24} textDecorationLine={hovered ? "underline" : "none"}>
										Shipping and Returns
									</Text>
								)}
							/>
						</Box>
						{region == "au" && (
							<Box flex={2} gap={4}>
								<Text color="$basicwhite">© {new Date().getFullYear()} Abco Products Pty Ltd</Text>
								<Text color="$basicwhite" lineHeight={24} fontFamily="calibri" flexWrap="wrap" style={{ flex: 1, flexWrap: "wrap" }}>
									Abco acknowledges the Traditional Owners of the land where we work and live. We pay our respects to Elder's past, present and emerging. We celebrate the stories, culture and traditions of Aboriginal and
									Torres Strait Islanders of all communities who also work and live on this land.
								</Text>
							</Box>
						)}

						{region == "nz" && (
							<Box flex={2} gap={4}>
								<Text color="$basicwhite">© {new Date().getFullYear()} Proquip Ltd</Text>
							</Box>
						)}
						{region === "nz" && (
							<Box flex={1}>
								<Link href="http://www.bsc.org.nz/">
									<RNImage style={{ marginBottom: 32, width: 200, height: 100 }} resizeMode="contain" source={require("../../assets/bsc-logo-white.png")} />
								</Link>
							</Box>
						)}
					</Box>
				</Box>
			</Box>
		</View>
	);
};

export default Footer;
